export default __webpack_public_path__ + "static/media/Cocktail.a5935d31.svg";